import * as React from "react";
import { Offer } from "./Cruise";
import * as style from "./Cruise.style";
import { Helmet } from "react-helmet";

const SunsetContent: React.FC = () => {
  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="Enjoy the beautiful sunset over the Rehoboth Bay from the Octolounge or the Kraken with this sunset cruise. Book Now!"
        />
        <title>Dewey Beach and Rehoboth Beach Sunset Cruise</title>
      </Helmet>
      <div className={style.subHeader}>How it goes:</div>
      <div className={style.details}>
        The sunset cruise is one of our most popular trips. Available on both
        the Octolounge and the Kraken, each offers a relaxed cruise through
        canals or along waterfront homes—with the option for a swim.
      </div>
      <div className={style.details}>
        For the best sunset view on the bay, nothing beats the Kraken's top
        deck.
      </div>
    </>
  );
};

const Sunset: React.FC = () => {
  return (
    <Offer
      title="Sunset Cruise"
      description="2 Hours &bull; All Ages &bull; Private Group of Up to 13 People"
      imageUrl="/dewey-booze-cruise-lg.png"
      imageAlt="Dewey Beach Booze Cruise"
      children={<SunsetContent />}
    />
  );
};

Sunset.displayName = "Sunset";
export { Sunset };
